import React from "react";
import { PackageX, UserX, SprayCan, Car, Clock4, DoorClosed } from "lucide-react";

const THREATS = [
  { icon: PackageX, label: "Package theft" },
  { icon: UserX, label: "Trespassing" },
  { icon: SprayCan, label: "Vandalism" },
  { icon: Car, label: "Auto break-ins" },
  { icon: Clock4, label: "Loitering" },
  { icon: DoorClosed, label: "Unauthorized access" },
];

const ThreatsBar = () => (
  <section className="bg-[#F8FAFC] border-y border-[#0F172A]/[0.06] py-16 lg:py-20">
    <div className="max-w-7xl mx-auto px-6">
      <div data-reveal className="text-center max-w-2xl mx-auto mb-12">
        <h2 className="font-head text-3xl sm:text-4xl font-semibold tracking-tight text-[#0F172A]">
          Stop the incidents that hurt communities most.
        </h2>
        <p className="text-[#0F172A]/55 mt-4 text-lg">
          A live guard actively watching means crime is prevented at your property — not reviewed after it happens.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {THREATS.map((t, i) => (
          <div key={t.label} data-reveal data-reveal-delay={(i % 6)}
               className="flex flex-col items-center text-center gap-3 rounded-xl bg-white border border-[#0F172A]/[0.07] p-5 hover:border-[#D32F2F]/40 transition-colors">
            <span className="w-11 h-11 rounded-full bg-[#D32F2F]/10 flex items-center justify-center">
              <t.icon className="w-5 h-5 text-[#D32F2F]" />
            </span>
            <span className="text-sm font-semibold text-[#0F172A] leading-tight">{t.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ThreatsBar;
